import request from "./http";

class UserRepository
{
    async create(user) {
        const path = "users/create";
        const method = "POST";
        const data = user;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }

    async edit(user) {
        const path = "users/edit";
        const method = "POST";
        const data = user;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }

    async gridview(query) {
        const path = "users/gridview";
        const method = "POST";
        const data = query;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }

    async getOneById(id) {
        const path = "users/get";
        const method = "GET";
        const data = {
            id: id
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get one by id", error);
        }
    }

    async resetPassword(id) {
        const path = "users/reset-password";
        const method = "POST";
        const data = {
            id: id
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }
}

export default UserRepository;